/**
 * My support packages component script
 */
export const MySupportPackages = (function () {
  var csrfHeaders = function () {
    return {
      "x-csrf-token":
        '{"csrf_name":"' +
        $("#csrf_name").val() +
        '","csrf_value":"' +
        $("#csrf_value").val() +
        '"}',
    };
  };

  /**
   * Setup each component of this type on the page - FYI they are 'key' based because potentially there can be more than one,
   * and keys stop them conflicting
   */
  //populate the referenced (by key) support-packages list
  var populateTableKey = function (key) {
    var qString = "";
    $('.existing-inputs input[data-attr-key="' + key + '"]').each(function () {
      qString += $(this).val() + ",";
    });

    $.get(
      MaMFormHandler.getBaseUrl() +
        "/get-table/support-package?key=" +
        key +
        "&records=" +
        qString,
      function (res) {
        $('.packages-table-list[data-attr-key="' + key + '"]').html("");
        $.each(res, function (i, val) {
          if (typeof val.title == "undefined" || val.title == "") {
            val.title = "Support Package";
          }

          var outputHtml = "<tr data-attr-id='" + val.id + "'><td>";
          outputHtml += "<h5>" + val.title + "</h5>";
          outputHtml += "<small>Supported by</small>: ";

          $.each(val.supporting_contacts, function (ii, supportingContact) {
            outputHtml += supportingContact.organisation_name + " ";
          });
          outputHtml += "<br />";
          outputHtml += "<ul>";

          $.each(val.support_schedule, function (ii, supportSchedule) {
            outputHtml += "<li>";
            outputHtml += supportSchedule.frequency;
            outputHtml += " on " + supportSchedule.week_day;
            if (supportSchedule.month_day) {
              outputHtml += " (" + supportSchedule.month_day + ")";
            }
            outputHtml += " from: " + supportSchedule.start_time;
            outputHtml += " to: " + supportSchedule.end_time;
            outputHtml += " - " + supportSchedule.location + "</li>";
          });
          outputHtml += "</ul>";

          outputHtml +=
            "</td>" +
            "<td class='text-center'>" +
            "<button class='btn btn-sm btn-secondary btn-edit-package'>Edit</button>" +
            "<button class='btn btn-sm btn-outline btn-remove-package'>Remove</button>" +
            "</td>" +
            "</tr>";

          $('.packages-table-list[data-attr-key="' + key + '"]').append(
            outputHtml
          );
          $(
            '.my-people-relationship-list-items[data-attr-key="' + key + '"]'
          ).removeClass("populate-me");
        });

        if (res.length < 1) {
          $('.packages-table-list[data-attr-key="' + key + '"]').append(
            "<tr><td colspan='3'>No support packages</td></tr>"
          );
        }
        initListeners();
      },
      "json"
    );
  };

  /**
   * Initialize click listeners on the relevant table row data
   */
  var initListeners = function () {
    $(".btn-remove-row")
      .off("click")
      .on("click", function () {
        $(this).closest(".row").remove();
        return false;
      });

    $(".btn-remove-package")
      .off("click")
      .on("click", function () {
        if (!confirm("Delete support package - are you sure?")) {
          return false;
        }
        var rowId = $(this).closest("tr").attr("data-attr-id");
        var key = $(this).closest(".packages-table-list").attr("data-attr-key");

        $.post({
          url:
            MaMFormHandler.getBaseUrl() +
            "/delete-table-row?id=" +
            rowId +
            "&mode=support-package",
          headers: csrfHeaders(),
          success: function (res) {
            $('tr[data-attr-id="' + rowId + '"]').remove();
            $(
              '.add-schedule-rows[data-attr-key="' +
                key +
                '"] .add-schedule-row'
            ).remove();
          },
          dataType: "json",
        });

        return false;
      });

    $(".btn-edit-package")
      .off("click")
      .on("click", function () {
        var rowId = $(this).closest("tr").attr("data-attr-id");
        var key = $(this).closest(".packages-table-list").attr("data-attr-key");
        $(".add-schedule-rows .add-schedule-row").remove();
        $(".btn-add-schedule-row").removeClass("d-none");
        $(".edit-package-title").removeClass("d-none");
        $(".btn-cancel-edit").removeClass("d-none");
        $(".add-edit-controls").removeClass("d-none");
        $(".btn-add-support-package").addClass("d-none");
        $(
          '.support-package-container[data-attr-key="' +
            key +
            '"] .input-errors'
        ).html("");
        $('.input-error[data-attr-key="' +key +'"]').html("");
        
        $.get(
          MaMFormHandler.getBaseUrl() +
            "/get-table/support-package?type=support-package&row=" +
            rowId,
          function (res) {
            MyPeople.clearTableKey("supporting_contacts");

            $.each(res.supporting_contacts, function (i, supportingContact) {
              $("#myPeopleContainer-supporting_contacts").append(
                '<input type="hidden" data-attr-peopleid="' +
                  supportingContact.id +
                  '" class="load-people" />'
              );
            });

            MyPeople.populateTableKey("supporting_contacts");

            $(
              '.support-schedule-input[name="title"][data-attr-key="' +
                key +
                '"]'
            ).val(res.title);

            var rowIndex = 0;
            $.each(res.support_schedule, function (i, supportSchedule) {
              var mainRowSchedule = $(
                '.add-schedule-row-main[data-attr-key="' + key + '"]'
              )
                .clone()
                .removeClass("add-schedule-row-main")
                .removeClass("d-none")
                .addClass("add-schedule-row");

              var rowHtml = $(mainRowSchedule).html();
              rowHtml = rowHtml.replaceAll("--idx--", rowIndex);
              $('.add-schedule-rows[data-attr-key="' + key + '"]').append(
                rowHtml
              );
              var addedElement = $(
                '.add-schedule-row[data-attr-idx="' + rowIndex + '"]'
              );
              $(addedElement)
                .find('[name="support_schedule[' + rowIndex + '][frequency]"]')
                .val(supportSchedule.frequency);
              $(addedElement)
                .find('[name="support_schedule[' + rowIndex + '][month_day]"]')
                .val(supportSchedule.month_day);
              $(addedElement)
                .find('[name="support_schedule[' + rowIndex + '][week_day]"]')
                .val(supportSchedule.week_day);
              $(addedElement)
                .find('[name="support_schedule[' + rowIndex + '][start_time]"]')
                .val(supportSchedule.start_time);
              $(addedElement)
                .find('[name="support_schedule[' + rowIndex + '][end_time]"]')
                .val(supportSchedule.end_time);
              $(addedElement)
                .find('[name="support_schedule[' + rowIndex + '][location]"]')
                .val(supportSchedule.location);

              rowIndex = rowIndex + 1;
              $('.add-schedule-row-main[data-attr-key="' + key + '"]').attr(
                "data-attr-rows",
                rowIndex
              );
              $(".support-package-add")
                .attr("data-attr-id", rowId)
                .html("Save support package");
              initListeners();
            });
          }
        );

        return false;
      });

    $(".btn-cancel-edit")
      .off("click")
      .on("click", function () {
        var key = $(this).attr("data-attr-key");

        $(
          '.add-schedule-rows[data-attr-key="' + key + '"] .add-schedule-row'
        ).remove();
        $(".support-package-add")
          .attr("data-attr-id", "new")
          .html("Save support package");
        $(this).addClass("d-none");
        $(".add-edit-controls").addClass("d-none");
        $(".btn-add-schedule-row").addClass("d-none");
        $(".btn-add-support-package").removeClass("d-none");
        $(".add-package-title").addClass("d-none");

        return false;
      });

    $(".btn-add-schedule-row")
      .off("click")
      .on("click", function () {
        var key = $(this).attr("data-attr-key");

        var mainRowSchedule = $(
          '.add-schedule-row-main[data-attr-key="' + key + '"]'
        )
          .clone()
          .removeClass("add-schedule-row-main")
          .removeClass("d-none")
          .addClass("add-schedule-row");
        var rowIndex = parseInt(
          $('.add-schedule-row-main[data-attr-key="' + key + '"]').attr(
            "data-attr-rows"
          )
        );
        var rowHtml = $(mainRowSchedule).html();
        rowHtml = rowHtml.replaceAll("--idx--", rowIndex);

        var firstLocation = $(
          ".add-schedule-rows .add-schedule-row .support-schedule-location"
        )
          .first()
          .val();
        if (typeof firstLocation == "undefined") {
          firstLocation = "";
        }
        rowHtml = rowHtml.replaceAll("--location--", firstLocation);

        $('.add-schedule-rows[data-attr-key="' + key + '"]').append(rowHtml);
        $('.add-schedule-row-main[data-attr-key="' + key + '"]').attr(
          "data-attr-rows",
          rowIndex + 1
        );
        $('.add-schedule-rows[data-attr-key="' + key + '"] .add-schedule-row .btn-add-schedule-row').removeClass('d-none');

        initListeners();

        return false;
      });
  };

  /**
   * Basic component initialization, loops over each component of this type and populates it/sets up listeners
   */
  var init = function () {
    $(".packages-table-list.populate-me").each(function () {
      var key = $(this).attr("data-attr-key");
      populateTableKey(key);
    });

    $(".btn-add-support-package")
      .off("click")
      .on("click", function () {
        var key = $(this).attr("data-attr-key");

        $(".add-edit-controls").removeClass("d-none");

        $(".edit-package-title").addClass("d-none");
        $(".add-package-title").removeClass("d-none");
        $(".btn-cancel-edit").removeClass("d-none");
        $(
          '.support-package-container[data-attr-key="' +
            key +
            '"] .input-errors'
        ).html("");

        $(
          '.support-schedule-input[name="title"][data-attr-key="' + key + '"]'
        ).val("");
        $(".contacts-search").val("");

        MyPeople.clearTableKey("supporting_contacts");

        $(".btn-add-schedule-row")
          .first()
          .removeClass("d-none")
          .trigger("click");
        $(".btn-add-support-package").addClass("d-none");
        $(".add-package-title").removeClass("d-none");

        return false;
      });



    $(".support-package-add")
      .off("click")
      .on("click", function () {
        var key = $(this).attr("data-attr-key");
        var itemKey = $(this).attr("data-attr-id");

        if (
          $(".add-schedule-rows[data-attr-key='" + key + "'] .add-schedule-row")
            .length < 1
        ) {
          $('.btn-add-schedule[data-attr-key="' + key + '"]').trigger("click");
          alert("You must add a support schedule");
          return false;
        }

        $(
          '.support-package-container[data-attr-key="' +
            key +
            '"] .input-errors'
        ).html("");

        var payload = {};

        $(
          ".add-schedule-rows[data-attr-key='" +
            key +
            "'] input," +
            ".add-schedule-rows[data-attr-key='" +
            key +
            "'] select, input.input-contacts, input.support-schedule-input[data-attr-key='" +
            key +
            "']"
        ).each(function () {
          if (typeof $(this).attr("name") != "undefined") {
            if (
              $(this).attr("name") != "csrf_name" &&
              $(this).attr("name") != "csrf_value"
            ) {
              payload[$(this).attr("name")] = $(this).val();
            }
          }
        });

        payload["supporting_contacts[my_contacts]"] = [];
        $(".custom-append-to[data-attr-key='supporting_contacts']").each(
          function () {
            payload["supporting_contacts[my_contacts]"].push($(this).val());
          }
        );

        var url =
          MaMFormHandler.getBaseUrl() + "/add-table-row/support-packages?"; //key=" + key
        if (itemKey != "new") {
          url =
            MaMFormHandler.getBaseUrl() + "/update-table-row/support-packages?";
        }

        $.post({
          url: url + "&item-key=" + itemKey,
          data: payload,
          headers: csrfHeaders(),
          success: function (res) {
            if (res.success) {
              //reset the add support package form
              $('.input-contacts[data-attr-key="' + key + '"]').val("");
              $(".add-schedule-rows .add-schedule-row").remove();
              $(".support-package-add")
                .attr("data-attr-id", "new")
                .html("Add support package");
              $(".btn-cancel-edit").addClass("d-none");
              $(".add-edit-controls").addClass("d-none");
              $(".btn-add-schedule-row").addClass("d-none");
              $(".btn-add-support-package").removeClass("d-none");
              $(".add-package-title").addClass("d-none");

              var lastItemId = res.response_data.last_insert_id;
              if (itemKey != "new") {
                lastItemId = res.response_data.last_updated_id;
              }
              $('.existing-inputs[data-attr-key="' + key + '"]').append(
                '<input type="hidden" name="inputs[' +
                  key +
                  '][my_support_packages][]" class="bsave bsave-multi" value="' +
                  lastItemId +
                  '" data-attr-key="' +
                  key +
                  '" />'
              );
              MaMFormHandler.init();
              $(
                '.existing-inputs[data-attr-key="' + key + '"] .bsave:first'
              ).trigger("blur");
              populateTableKey(key);
            } else {
              var message = res.message.split(": ");
              var errorField = message[0];
              var errorMessage = message[1];

              Util.toggleAlert(
                ".alert",
                "Error: Please correct the form errors",
                "alert-warning"
              );

              $(
                '.support-package-container[data-attr-key="' +
                  key +
                  '"] .input-error-' +
                  errorField
              ).html(errorMessage);
            }
          },
        });

        return false;
      });
  };

  return {
    init: init,
  };
})();
